import { NgModule } from '@angular/core';
import { LogService } from '~gc/shared/services/log.service';

@NgModule({
  providers: [LogService],
})
export class LogModule {}
